import { useState, useEffect } from 'react';
export var BREAKPOINTS = {
  mobile: 768,
  tablet: 1024,
  desktop: 1025
};
export var useResponsiveV2 = function useResponsiveV2() {
  var _useState = useState(function () {
    var width = true ? window.innerWidth : 1920;
    return getResponsiveState(width);
  }),
      state = _useState[0],
      setState = _useState[1];

  useEffect(function () {
    var handleResize = function handleResize() {
      setState(getResponsiveState(window.innerWidth));
    };

    window.addEventListener('resize', handleResize);
    return function () {
      return window.removeEventListener('resize', handleResize);
    };
  }, []);
  return state;
};

var getResponsiveState = function getResponsiveState(width) {
  if (width <= BREAKPOINTS.mobile) {
    return {
      isMobile: true,
      isTablet: false,
      isDesktop: false,
      breakpoint: 'mobile',
      width: width
    };
  }

  if (width <= BREAKPOINTS.tablet) {
    return {
      isMobile: false,
      isTablet: true,
      isDesktop: false,
      breakpoint: 'tablet',
      width: width
    };
  }

  return {
    isMobile: false,
    isTablet: false,
    isDesktop: true,
    breakpoint: 'desktop',
    width: width
  };
};

export var media = {
  mobile: "@media (max-width: ".concat(BREAKPOINTS.mobile, "px)"),
  tablet: "@media (min-width: ".concat(BREAKPOINTS.mobile + 1, "px) and (max-width: ").concat(BREAKPOINTS.tablet, "px)"),
  desktop: "@media (min-width: ".concat(BREAKPOINTS.desktop, "px)"),
  tabletAndAbove: "@media (min-width: ".concat(BREAKPOINTS.mobile + 1, "px)"),
  mobileAndTablet: "@media (max-width: ".concat(BREAKPOINTS.tablet, "px)")
};